(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aoctant-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__aoctantFaqBound) return;
    window.__aoctantFaqBound = true;

    const setOpen = (item, open) => {
      item.classList.toggle('is-open', open);
      const trigger = item.querySelector('[data-aoctant-faq-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', String(open));
    };

    const toggle = (item, forceOpen) => {
      const root = item.closest('[data-aoctant-faq]');
      const open = forceOpen ?? !item.classList.contains('is-open');
      if (open && root && root.dataset.singleOpen === 'true') {
        root.querySelectorAll('[data-aoctant-faq-item].is-open').forEach((other) => {
          if (other !== item) setOpen(other, false);
        });
      }
      setOpen(item, open);
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-aoctant-faq-trigger]');
      if (!trigger) return;
      const item = trigger.closest('[data-aoctant-faq-item]');
      if (item) toggle(item);
    });

    // Theme editor: open the FAQ item whose block is selected.
    document.addEventListener('shopify:block:select', (event) => {
      const item = event.target.closest && event.target.closest('[data-aoctant-faq-item]');
      if (item) toggle(item, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
